import { useCallback, useState } from "react";
import { Auth } from "shared/@auth/Auth";
import { useLogger } from "shared/@hooks/useLogger";

export const actionTypes = {
  card: "card",
  ach: "ach",
};

export function useRefund({ iboNumber, transaction }) {
  const { logError } = useLogger({ prefix: "useRefund" });
  const { makeAuthedRequest } = Auth.useContainer();

  const [isWaiting, setIsWaiting] = useState(false);
  const [actionType, setActionType] = useState(actionTypes.card);
  const [reason, setReason] = useState("");
  const [hcTraceId, setHcTraceId] = useState("");

  // TODO: Make this a proper number. Waiting on MoneyInput component.
  const [amount, setAmount] = useState("");

  const submit = useCallback(async () => {
    setIsWaiting(true);

    const body = JSON.stringify({
      transactionId: transaction.id,
      action: actionType,
      reason,
      amount: Number(amount),
      ccId: actionType === actionTypes.card ? transaction.ccId : null,
      hcTraceId: actionType === actionTypes.ach ? hcTraceId : null,
    });

    console.log({ body, amount, parse: Number(amount) });

    return makeAuthedRequest(
      `/v1/v1/membership/transactions/${iboNumber}/delivery`,
      {
        method: "PUT",
        body,
      }
    )
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const json = await res.json();
          throw new Error(json.message);
        }
      })
      .catch(logError)
      .finally(() => {
        setIsWaiting(false);
      });
  }, [
    iboNumber,
    hcTraceId,
    makeAuthedRequest,
    transaction,
    actionType,
    reason,
    amount,
  ]);

  return {
    submit,
    isWaiting,

    actionType,
    setActionType,

    reason,
    setReason,

    amount,
    setAmount,
  };
}
